export const TRANSACTION_STATUSES = {
  AuthorizeApproved: {
    name: "Authorize Approved",
    colour: "blue",
    capture: true,
    reversal: true,
    display: true
  },
  AuthorizeDeclined: { name: "Authorize Declined", colour: "red" },
  AuthorizeError: { name: "Authorize Error", colour: "gray" },
  Collected: {
    name: "Collected",
    colour: "green",
    display: true,
    partialRefund: true,
    refund: true
  },
  CollectedError: {
    name: "Collected Error",
    colour: "dark-red",
    display: true,
    capture: true,
    reversal: true
  },
  CollectedDeclined: {
    name: "Collected Declined",
    colour: "red"
  },
  "Fund CollectionRequested": {
    name: "Collection Requested",
    colour: "green",
    props: {
      outlined: true
    },
    display: true
  },
  PartialRefund: {
    name: "Partial Refund",
    colour: "",
    display: true,
    refund: true
  },
  PartialRefundError: {
    name: "Partial Refund Error",
    colour: "purple",
    display: true,
    partialRefund: true,
    refund: true
  },
  "Partial RefundRequested": {
    name: "Partial Refund Requested",
    colour: "",
    props: {
      outlined: true
    },
    display: true
  },
  RecurringInitialised: {
    name: "Recurring Initialised",
    colour: "light-green",
    display: true,
    reversal: true
  },
  RecurringScheduled: {
    name: "Recurring Scheduled",
    colour: "light-blue",
    display: true
  },
  RecurringDeclined: { name: "Recurring Declined", colour: "red" },
  RecurringError: { name: "Recurring Error", colour: "gray" },
  RecurringApproved: {
    name: "Recurring Approved",
    colour: "green",
    display: true,
    partialRefund: true,
    refund: true
  },
  Refund: { name: "Refunded", colour: "#555", display: true },
  RefundError: {
    name: "Refund Error",
    colour: "purple",
    display: true,
    refund: true
  },
  RefundRequested: {
    name: "Refund Requested",
    colour: "#555",
    props: {
      outlined: true
    },
    display: true
  },
  Reversal: { name: "Reversed", colour: "orange", display: true },
  ReversalError: {
    name: "Reversal Error",
    display: true,
    capture: true,
    reversal: true
  },
  ReversalRequested: {
    name: "Reversal Requested",
    colour: "orange",
    props: {
      outlined: true
    },
    display: true
  }
};

export const GET_TRANSACTION_STATUS_ARRAY = () => {
  let transactionStatusArray = [];
  for (let key in TRANSACTION_STATUSES) {
    if (TRANSACTION_STATUSES.hasOwnProperty(key)) {
      transactionStatusArray.push({
        value: key,
        text: TRANSACTION_STATUSES[key].name
      });
    }
  }
  return transactionStatusArray;
};
